import React, { useContext } from "react";
import ListFilter from "Components/listFilter/ListFilter";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import ButtonIcon from "Components/buttonIcon/ButtonIcon";
import PaginationFilter from "Components/paginationFilter/PaginationFilter";
import Pager from "Components/pager/Pager";
import PaginationShow from "Components/paginationShow/PaginationShow";
import { refresh } from "Icons/index";
import cx from "classnames";
import s from "./fullPaginationControls.scss";
import { MediaQueriesContext } from "../../App";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import qs from "query-string";

const FullPaginationControls = ({
  className,
  paginationInfo,
  isLoading,
  refreshList,
  totals,
  listFilters,
  listFilterParam,
  listFilterLegends,
  showListFilter = true,
  showPager = true,
  showRefreshButton = true,
  showPaginationFilter = true,
  showPagination = true,
  showCustomerSelection = false,
  paginationShowOptions,
  shortenPagesOver,
  labelPrefix,
}) => {
  const { isMediaMobile, isMediaSM } = useContext(MediaQueriesContext);
  const { search } = useLocation();
  const history = useHistory();
  const location = useLocation();
  const query = qs.parse(search);

  const onCustomerSelection = (customer) => {
    if (customer) {
      history.push({
        pathname: location.pathname,
        search: qs.stringify({
          ...qs.parse(location.search),
          customer_code: customer.value,
          page: 1,
          per: 25,
        }),
        state: { prevPathname: location.pathname },
      });
    } else {
      const search = qs.parse(location.search);
      // eslint-disable-next-line no-unused-vars
      const { customer_code, ...queryParams } = search;

      history.push({
        pathname: location.pathname,
        search: qs.stringify({
          ...queryParams,
          page: 1,
          per: 25,
        }),
        state: { prevPathname: location.pathname },
      });
    }
  };

  return (
    <div
      className={cx(className, s.filterContainer, {
        [s.showListFilter]: showListFilter,
        [s.showCustomer]: showCustomerSelection,
        [s.showPaginationFilter]: showPaginationFilter,
      })}
    >
      {showListFilter && (
        <ListFilter
          className={s.statusFilter}
          values={listFilters}
          active={listFilterParam ? query[listFilterParam] : query.status}
          location={location}
          labelPrefix={labelPrefix}
          paginationInfo={paginationInfo}
          legendIcons={listFilterLegends}
          param={listFilterParam || "status"}
          url={location.pathname}
          totals={paginationInfo.totals || totals}
        />
      )}

      {showPaginationFilter && (
        <PaginationFilter
          className={s.searchList}
          url={location.pathname}
          currentQuery={query.query}
          paginationFilter={query}
        />
      )}

      {!isMediaMobile && !isMediaSM && showCustomerSelection && (
        <CustomerSelect
          className={s.customersSelect}
          initialValue={query.customer_code}
          onChange={onCustomerSelection}
          noLabel
        />
      )}

      {showRefreshButton && (
        <ButtonIcon
          className={cx(s.iconRefresh, { ["isRefreshing"]: isLoading })}
          icon={refresh}
          onClick={isLoading ? () => {} : refreshList}
        />
      )}

      {!isMediaMobile && showPagination && (
        <PaginationShow className={s.pageShow} options={paginationShowOptions} history={history} location={location} />
      )}

      {showPager && (
        <Pager
          className={s.pagination}
          paginationInfo={{ ...query, ...paginationInfo }}
          url={location.pathname}
          shortenPagesOver={shortenPagesOver}
        />
      )}
    </div>
  );
};

export default FullPaginationControls;
